import Color from './Color'
import Card from './Card'
import Level from './Level'
import Reward from './Reward'
import Branch from './Branch'
import ProductExchangeRate from './ProductExchangeRate'
import Promotion from './Promotion'
import Blog from './Blog'
import Package from './Package'
import PackageQRcode from './PackageQRcode'
import Editv2 from './Editv2'
import AddCoin from './AddCoin'
import Redeem from './Redeem'
import trade from './trade'
import DashBoard from './DashBoard'
import addpoint from './addpoint'
import DataMemberByBarcode from './DataMemberByBarcode'
import Discount from './Discount'

export default {
  Color,
  Card,
  Level,
  Reward,
  ProductExchangeRate,
  Branch,
  Promotion,
  Blog,
  Package,
  PackageQRcode,
  Editv2,
  AddCoin,
  Redeem,
  trade,
  DashBoard,
  addpoint,
  DataMemberByBarcode,
  Discount
}



// WEBPACK FOOTER //
// ./src/components/Master/index.js